import { render, staticRenderFns } from "./EmploymentGrantsView.vue?vue&type=template&id=11c2bd5a&scoped=true&"
import script from "./EmploymentGrantsView.vue?vue&type=script&lang=ts&"
export * from "./EmploymentGrantsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c2bd5a",
  null
  
)

export default component.exports